module.exports = __webpack_public_path__ + "img/lg_ring_r_c_0_1.27f40099.png";